import { render } from "./LoginApp.vue?vue&type=template&id=2cdfb635&scoped=true"
import script from "./LoginApp.vue?vue&type=script&lang=js"
export * from "./LoginApp.vue?vue&type=script&lang=js"

import "./LoginApp.vue?vue&type=style&index=0&id=2cdfb635&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdfb635"]])

export default __exports__